// extracted by mini-css-extract-plugin
export default {"homeContent":"Home_homeContent__4zAun"};